import React from "react";
import { AppBar, Toolbar, Button, Typography } from "@mui/material";
import FlightIcon from "@mui/icons-material/Flight";

const SplashNavBar: React.FC = () => {
  const handleSignUp = () => {
    window.location.href = "/signup";
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: 10,
      }}
    >
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          <FlightIcon style={{ transform: "rotate(90deg)" }} />
        </Typography>
        <Button variant="contained" onClick={handleSignUp}>
          Get Started FREE
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default SplashNavBar;
